/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedHotelRateSummary } from "./SharedHotelRateSummary";
import {
  SharedHotelRateSummaryFromJSON,
  SharedHotelRateSummaryFromJSONTyped,
  SharedHotelRateSummaryToJSON,
  SharedHotelRateSummaryToJSONTyped,
} from "./SharedHotelRateSummary";
import type { SharedHotelTextSection } from "./SharedHotelTextSection";
import {
  SharedHotelTextSectionFromJSON,
  SharedHotelTextSectionFromJSONTyped,
  SharedHotelTextSectionToJSON,
  SharedHotelTextSectionToJSONTyped,
} from "./SharedHotelTextSection";
import type { SharedHotelRawRateSummary } from "./SharedHotelRawRateSummary";
import {
  SharedHotelRawRateSummaryFromJSON,
  SharedHotelRawRateSummaryFromJSONTyped,
  SharedHotelRawRateSummaryToJSON,
  SharedHotelRawRateSummaryToJSONTyped,
} from "./SharedHotelRawRateSummary";

/**
 * Explicit public confirmation display fields; never contains booking identifiers, guest details, credentials, earnings or payment metadata.
 * @export
 * @interface SharedHotelBooking
 */
export interface SharedHotelBooking {
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  hotelName?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  hotelAddress?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  roomName?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  checkin?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  checkout?: string;
  /**
   *
   * @type {number}
   * @memberof SharedHotelBooking
   */
  nights?: number;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  total?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  nightlyRate?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  cancellationSummary?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  heroImage?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  checkinTime?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  checkoutTime?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  occupancy?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  supplierRateName?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelBooking
   */
  roomDescription?: string;
  /**
   *
   * @type {boolean}
   * @memberof SharedHotelBooking
   */
  usedGondolaCredits?: boolean;
  /**
   *
   * @type {number}
   * @memberof SharedHotelBooking
   */
  minCheckinAge?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SharedHotelBooking
   */
  cancellationPolicies?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SharedHotelBooking
   */
  checkinInstructions?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SharedHotelBooking
   */
  specialInstructions?: Array<string>;
  /**
   *
   * @type {Array<SharedHotelTextSection>}
   * @memberof SharedHotelBooking
   */
  policies?: Array<SharedHotelTextSection>;
  /**
   *
   * @type {Array<SharedHotelTextSection>}
   * @memberof SharedHotelBooking
   */
  fees?: Array<SharedHotelTextSection>;
  /**
   *
   * @type {SharedHotelRateSummary}
   * @memberof SharedHotelBooking
   */
  rateSummary?: SharedHotelRateSummary;
  /**
   *
   * @type {SharedHotelRawRateSummary}
   * @memberof SharedHotelBooking
   */
  rawRateSummary?: SharedHotelRawRateSummary;
}

/**
 * Check if a given object implements the SharedHotelBooking interface.
 */
export function instanceOfSharedHotelBooking(
  value: object
): value is SharedHotelBooking {
  return true;
}

export function SharedHotelBookingFromJSON(json: any): SharedHotelBooking {
  return SharedHotelBookingFromJSONTyped(json, false);
}

export function SharedHotelBookingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelBooking {
  if (json == null) {
    return json;
  }
  return {
    hotelName: json["hotel_name"] == null ? undefined : json["hotel_name"],
    hotelAddress:
      json["hotel_address"] == null ? undefined : json["hotel_address"],
    roomName: json["room_name"] == null ? undefined : json["room_name"],
    checkin: json["checkin"] == null ? undefined : json["checkin"],
    checkout: json["checkout"] == null ? undefined : json["checkout"],
    nights: json["nights"] == null ? undefined : json["nights"],
    status: json["status"] == null ? undefined : json["status"],
    total: json["total"] == null ? undefined : json["total"],
    nightlyRate:
      json["nightly_rate"] == null ? undefined : json["nightly_rate"],
    cancellationSummary:
      json["cancellation_summary"] == null
        ? undefined
        : json["cancellation_summary"],
    heroImage: json["hero_image"] == null ? undefined : json["hero_image"],
    checkinTime:
      json["checkin_time"] == null ? undefined : json["checkin_time"],
    checkoutTime:
      json["checkout_time"] == null ? undefined : json["checkout_time"],
    occupancy: json["occupancy"] == null ? undefined : json["occupancy"],
    supplierRateName:
      json["supplier_rate_name"] == null
        ? undefined
        : json["supplier_rate_name"],
    roomDescription:
      json["room_description"] == null ? undefined : json["room_description"],
    usedGondolaCredits:
      json["used_gondola_credits"] == null
        ? undefined
        : json["used_gondola_credits"],
    minCheckinAge:
      json["min_checkin_age"] == null ? undefined : json["min_checkin_age"],
    cancellationPolicies:
      json["cancellation_policies"] == null
        ? undefined
        : json["cancellation_policies"],
    checkinInstructions:
      json["checkin_instructions"] == null
        ? undefined
        : json["checkin_instructions"],
    specialInstructions:
      json["special_instructions"] == null
        ? undefined
        : json["special_instructions"],
    policies:
      json["policies"] == null
        ? undefined
        : (json["policies"] as Array<any>).map(SharedHotelTextSectionFromJSON),
    fees:
      json["fees"] == null
        ? undefined
        : (json["fees"] as Array<any>).map(SharedHotelTextSectionFromJSON),
    rateSummary:
      json["rate_summary"] == null
        ? undefined
        : SharedHotelRateSummaryFromJSON(json["rate_summary"]),
    rawRateSummary:
      json["raw_rate_summary"] == null
        ? undefined
        : SharedHotelRawRateSummaryFromJSON(json["raw_rate_summary"]),
  };
}

export function SharedHotelBookingToJSON(json: any): SharedHotelBooking {
  return SharedHotelBookingToJSONTyped(json, false);
}

export function SharedHotelBookingToJSONTyped(
  value?: SharedHotelBooking | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    hotel_name: value["hotelName"],
    hotel_address: value["hotelAddress"],
    room_name: value["roomName"],
    checkin: value["checkin"],
    checkout: value["checkout"],
    nights: value["nights"],
    status: value["status"],
    total: value["total"],
    nightly_rate: value["nightlyRate"],
    cancellation_summary: value["cancellationSummary"],
    hero_image: value["heroImage"],
    checkin_time: value["checkinTime"],
    checkout_time: value["checkoutTime"],
    occupancy: value["occupancy"],
    supplier_rate_name: value["supplierRateName"],
    room_description: value["roomDescription"],
    used_gondola_credits: value["usedGondolaCredits"],
    min_checkin_age: value["minCheckinAge"],
    cancellation_policies: value["cancellationPolicies"],
    checkin_instructions: value["checkinInstructions"],
    special_instructions: value["specialInstructions"],
    policies:
      value["policies"] == null
        ? undefined
        : (value["policies"] as Array<any>).map(SharedHotelTextSectionToJSON),
    fees:
      value["fees"] == null
        ? undefined
        : (value["fees"] as Array<any>).map(SharedHotelTextSectionToJSON),
    rate_summary: SharedHotelRateSummaryToJSON(value["rateSummary"]),
    raw_rate_summary: SharedHotelRawRateSummaryToJSON(value["rawRateSummary"]),
  };
}
